export enum StatusP2PTransferKey {
  Pending = 1,
  Acepted = 2,
  Rejected = 3,
  Canceled = 4,
}

export const StatusP2KeyPOption = {
  [StatusP2PTransferKey.Pending]: 'Pendiente',
  [StatusP2PTransferKey.Acepted]: 'Aceptado',
  [StatusP2PTransferKey.Rejected]: 'Rechazado',
  [StatusP2PTransferKey.Canceled]: 'Cancelado',
};
export const StatusP2PKeyOptionVerbo = {
  [StatusP2PTransferKey.Pending]: 'Pendiente(s)',
  [StatusP2PTransferKey.Acepted]: 'Aceptadas(s)',
  [StatusP2PTransferKey.Rejected]: 'Rechazada(s)',
  [StatusP2PTransferKey.Canceled]: 'Cancelada(s)',
};
